// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TransferTokens } from './type';

const transferTokens: TransferTokens = {
  transferFontSize: 'Font-14',
  transferFontColor: 'Neutral-text-5',
  transferHeaderHeight: 'Size-23',
  transferHeaderBackgroundColor: 'Neutral-fill-2',
  transferHeaderBorderColor: 'Transparent',
  transferSmallFontSize: 'Font-12',
  transferSmallHeaderHeight: 'Size-22',
  transferLargeFontSize: 'Font-16',
  transferLargeHeaderHeight: 'Size-24',
  transferBorderColor: 'Neutral-border-1',
  transferBorderRadius: 'Radius-default',
  transferIconColor: 'Neutral-text-4',
  transferIconBackgroundColor: 'Neutral-fill-3',
  transferIconNearlyMargin: 'Spacing-8',
  transferDisabledFontColor: 'Neutral-text-2',
  transferEmptyFontColor: 'Neutral-text-3',
  transferBackgroundColor: 'Neutral-fill-1',
  transferFooterBackgroundColor: 'Neutral-fill-1',
  transferFooterBorderColor: 'Neutral-border-1',
  transferItemHoverBackgroundColor: 'Neutral-fill-2',
  transferItemBorderRadius: 'Radius-default',
  transferRemoveIconColor: 'Neutral-text-4',
  transferCheckboxHoverBackgroundColor: 'Neutral-fill-3',
};

export default transferTokens;
